<template>
  <div>
    <inline-form :company="company" :editable="editable">

      <template slot="fields">
        <label for="v-company-mission-statement" class="cm-label">{{ I18n.t('activerecord.attributes.company.mission_statement') }}</label>
        <autosize-textarea id="v-company-mission-statement" class="cm-field" rows="3" v-model="company.mission_statement"/>
      </template>

      <p class="mission-statement" v-if="company.mission_statement">{{ company.mission_statement }}</p>
      <p class="mission-statement mission-statement--empty" v-else-if="editable">{{ I18n.t('add_a_mission_statement') }}</p>
    </inline-form>
  </div>
</template>

<script>
  import AutosizeTextarea from '../components/autosize-textarea'
  import InlineForm from './inline-form'

  export default {
    props: ['id', 'value', 'editable'],
    data: function () {
      return {
        company: {
          id: this.id,
          mission_statement: this.value
        }
      }
    },
    components: {
      AutosizeTextarea,
      InlineForm
    }
  }
</script>

<style scoped lang="scss">
  .mission-statement {
    @include h2;
    margin-bottom: 1rem;

    &--empty {
      color: var(--fg-2);
    }

    @include max-width($bp_left_sidebar_stacked){
      margin-bottom: $gutter;
    }
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/mission-statement.vue?56f45f8c